// Components
import { DownloadContainer } from "./styles";
import DownloadCSV from "./sections/downloadCSV";
import DownloadPDF from "./sections/downloadPDF";

const DownloadFiles = ({ sessionsData, plotsRef }) => {
  return (
    <DownloadContainer>
      <DownloadPDF sessionsData={sessionsData} plotsRef={plotsRef} />
      <DownloadCSV sessionsData={sessionsData} />
    </DownloadContainer>
  );
};

export default DownloadFiles;
